
import list from './list';

const userSagas = [
  ...list,
];

export default userSagas;